module.exports = __webpack_public_path__ + "static/media/dennis_3.d37fe916.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreWork/assets/dennis_3.png
// module id = 483
// module chunks = 0